import { useEffect, useState } from 'react';

/**
 * Diz se o cardapio esta rodando dentro do app desktop (Electron).
 *
 * O preload do gateway responde 'request-active-chat' com uma mensagem
 * 'flash-gateway'; no navegador ninguem responde. E a mesma deteccao usada em
 * Cart/OrderOrigin — o User-Agent do app e um Chrome comum de proposito, e
 * `iframe-running-on=painel` tambem vale para o painel aberto no navegador.
 */
export const useIsElectronGateway = () => {
  const [isElectronGateway, setIsElectronGateway] = useState(false);

  useEffect(() => {
    const onMessage = (event) => {
      const data = event && event.data;
      if (!data || data.source !== 'flash-gateway') return;
      setIsElectronGateway(true);
    };

    window.addEventListener('message', onMessage);
    try {
      window.postMessage({ source: 'flash-platform', type: 'request-active-chat' }, '*');
    } catch (_) { /* noop */ }

    return () => window.removeEventListener('message', onMessage);
  }, []);

  return isElectronGateway;
};
